import PropTypes from "prop-types";
import dayjs from "dayjs";
import {ListBox} from "primereact/listbox";
import "./InvoiceScroll.css"


export function InvoiceScroll(props) {

    function selectedInvoice(invId) {
        props.setInv(invId.id);
        props.setVisible(false);
    }

    const itemTemplate = (item) => {
        const dt = dayjs(item.date).format("DD-MM-YYYY").toString();

        // status → accent color (use as a classy left border, instead of painting the whole card)
        let accentColor;
        switch (item.status) {
            case "Posted":
                accentColor = "#9CA3AF"; // cool gray
                break;
            case "Invoiced":
                accentColor = "#F59E0B"; // amber
                break;
            case "Delivered":
                accentColor = "#60A5FA"; // blue
                break;
            case "Ready":
                accentColor = "#FBBF24"; // yellow
                break;
            case "Approved":
                accentColor = "#34D399"; // green
                break;
            default:
                accentColor = "#F472B6"; // pink
                break;
        }

        return (
            <div className="invoiceScrollItem" style={{ borderLeftColor: accentColor }}>
                <div className="invoiceScrollItem__left">
                    <div className="invoiceScrollItem__title">
                        Invoice <span className="invoiceScrollItem__id">#{item.id}</span>
                    </div>
                    <div className="invoiceScrollItem__meta">
                        <span className="invoiceScrollItem__date">{dt}</span>
                        <span className="invoiceScrollItem__dot">•</span>
                        <span className="invoiceScrollItem__customer">{item.customer}</span>
                    </div>
                </div>

                <div className="invoiceScrollItem__right">
                    <div className="invoiceScrollItem__status" style={{ backgroundColor: accentColor }}>
                        {item.status}
                    </div>
                    <div className="invoiceScrollItem__total">{item.total}</div>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="invoiceScrollShell">
                <ListBox
                    filter
                    value={props.invoices}
                    onChange={(e) => selectedInvoice(e.value)}
                    options={props.invoiceList}
                    itemTemplate={itemTemplate}
                    optionLabel="id"
                    className="invoiceScrollListBox"
                    listClassName="invoiceScrollListBox__list"
                />
            </div>
        </>
    );
}

InvoiceScroll.propTypes = {
    invoices: PropTypes.number.isRequired,
    setVisible: PropTypes.func.isRequired,
    invoiceList: PropTypes.array.isRequired,
};


